import BaseStore from 'stores/base'

export default class OrderStore extends BaseStore {
  constructor(service, options) {
    super(service)
    this.service = service
    this.options = options
  }
}
